import Story from "./story/thumbnail.es6";

const story = new Story();
